module.exports = __webpack_public_path__ + "static/media/Kavatar.170ff2c8.png";